module.exports = __webpack_public_path__ + "static/media/jennings-design-studio-architects.b3c1988e.png";